<template>
    <gz-auth-view-template>
        <GZ-PageTitle title="Дашбоард" slot="title"/>        
        <GZ-StaticNotification slot="notification"/>
        
        <gz-filters-bar slot="content">
            <div class="gz-filters" slot="filters">
                <span>Фильтры</span>
            </div>
            <!-- Data section -->
            <section slot="data">
               <span>Список</span>
            </section>
        </gz-filters-bar>
    </gz-auth-view-template>
</template>

<script>
export default {
    name: 'AdminDashboardView',

    components: {
    },
    data() {
        return {
            
        }
    },
    computed: {
        
    },
    mounted() {
        
    },
    methods: {
        getData() {
            
        }
    }
}
</script>